import { AXIOS_GET, AXIOS_POST, AXIOS_UPDATE } from "../server/api/crud";

export const fetchSupportTickets = async () => {
  const response = await AXIOS_GET("support/tickets");
  return response?.data?.data || [];
};

export const fetchSupportTicketById = async (ticketId) => {
  const response = await AXIOS_GET(`support/tickets/${ticketId}`);
  return response?.data?.data || { ticket: null, messages: [] };
};

export const createSupportTicket = async (payload) => {
  const response = await AXIOS_POST("support/tickets", payload);
  return response?.data?.data || { ticket: null, messages: [] };
};

export const sendSupportMessage = async (ticketId, payload) => {
  const response = await AXIOS_POST(`support/tickets/${ticketId}/messages`, payload);
  return response?.data?.data || { ticket: null, messages: [] };
};

export const markSupportTicketRead = async (ticketId) => {
  const response = await AXIOS_UPDATE("support/tickets/read", ticketId, {});
  return response?.data?.data || null;
};

export const updateSupportTicketStatus = async (ticketId, status) => {
  const response = await AXIOS_UPDATE("support/tickets/status", ticketId, {
    status,
  });
  return response?.data?.data || null;
};

export const assignSupportTicketAdmin = async (ticketId, assignedAdminId) => {
  const response = await AXIOS_UPDATE("support/tickets/assign", ticketId, {
    assigned_admin_id: assignedAdminId || null,
  });
  return response?.data?.data || null;
};
